<script>
import { createNeonHeistGame } from "./neonHeistEngine";

export default {
  name: "NeonHeistGame",
  data() {
    return {
      game: null,
      liveMessage: "NEON HEIST 888 พร้อมรับภารกิจ"
    };
  },
  mounted() {
    this.game = createNeonHeistGame(this.$refs.gameCanvas, {
      onComplete: score => {
        this.liveMessage = `ภารกิจสำเร็จ คะแนน ${score}`;
        this.$emit("complete", score);
      },
      onFail: reason => {
        this.liveMessage = `ภารกิจล้มเหลว ${reason}`;
        this.$emit("fail", reason);
      }
    });
  },
  beforeDestroy() {
    if (this.game) this.game.destroy();
  }
};
</script>

<template>
  <main class="heist-game" aria-label="NEON HEIST 888 เกมปล้นเพชรตัวอย่าง">
    <canvas
      ref="gameCanvas"
      class="heist-game__canvas"
      tabindex="0"
      aria-label="เกม NEON HEIST 888 ฝ่าเลเซอร์ แฮกระบบ ชิงเพชร และหลบหนี"
    ></canvas>
    <p class="heist-game__live" aria-live="polite">{{ liveMessage }}</p>
  </main>
</template>

<style scoped lang="scss">
.heist-game {
  position: fixed;
  inset: 0;
  z-index: 999;
  width: 100%;
  height: 100%;
  min-height: 100%;
  overflow: hidden;
  background: #03050a;
  overscroll-behavior: none;
  user-select: none;
  -webkit-user-select: none;
}

.heist-game__canvas {
  display: block;
  width: 100%;
  height: 100%;
  outline: none;
  cursor: crosshair;
  touch-action: none;
  -webkit-tap-highlight-color: transparent;
}

.heist-game__live {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}
</style>
